(()=>{
  document.querySelectorAll('[data-blanket-film]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const video=root.querySelector('video'),button=root.querySelector('[data-film-toggle]');
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    let visible=false,userPaused=false,manualPlay=false,failed=false;
    const restricted=()=>motion.matches||navigator.connection?.saveData;
    const poster=()=>{if(!video.poster)video.poster=video.dataset.poster;};
    const load=()=>{if(!video.getAttribute('src')){video.src=video.dataset.src;video.load();}};
    const update=()=>{
      const playing=!video.paused;
      button.setAttribute('aria-label',playing?button.dataset.pause:button.dataset.play);
      root.querySelector('[data-film-label]').textContent=playing?button.dataset.pause:button.dataset.play;
      root.querySelector('[data-film-play]').toggleAttribute('hidden',playing);
      root.querySelector('[data-film-pause]').toggleAttribute('hidden',!playing);
    };
    const play=()=>{if(failed)return;load();video.muted=true;video.play().catch(update);};
    const sync=()=>{
      if(!visible||document.hidden||userPaused||(restricted()&&!manualPlay))video.pause();
      else play();
    };
    button.hidden=false;
    button.addEventListener('click',()=>{
      if(video.paused){userPaused=false;manualPlay=true;play();}
      else{userPaused=true;manualPlay=false;video.pause();}
    });
    video.addEventListener('play',update);
    video.addEventListener('pause',update);
    video.addEventListener('error',()=>{
      failed=true;button.hidden=true;
      root.querySelector('[data-film-error]').textContent=root.querySelector('[data-film-error]').dataset.error;
      video.removeAttribute('src');video.load();
    },{once:true});
    document.addEventListener('visibilitychange',sync);
    motion.addEventListener('change',()=>{manualPlay=false;sync();});
    if('IntersectionObserver' in window){
      const preview=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){poster();preview.disconnect();}},{rootMargin:'600px'});
      preview.observe(root);
      const observer=new IntersectionObserver(entries=>{
        visible=entries[0].isIntersecting;sync();
      },{threshold:0.15});
      observer.observe(root);
    }else{poster();}
  });
})();
